module.exports = __webpack_public_path__ + "static/img/2.b28800b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/2.png
// module id = cnXJ
// module chunks = 0